export const aws_accessKeyId = 'AKIA3TTKYXI7H5EMIPBF';
export const aws_secretAccessKey = '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';

export const c3_lambdaRegion = 'us-west-2';

export const packages_bucketRegion = 'us-west-2';
export const packages_bucketName = 'jazel-c3-v2';
export const packages_keyPrefix = 'packages/';
